// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__48iaH","checkboxCol":"Table_checkboxCol__3qhnh","emailCol":"Table_emailCol__2XTLD","actionCol":"Table_actionCol__Oe93W"};